import { t } from "i18next";
import { useEffect } from "react";
import backgroundContentDefault from "../../../assets/images/custom-page-content.png";
import backgroundHeaderDefault from "../../../assets/images/custom-page-header.png";
import { ReactComponent as MessageQuestionCustomizeIcon } from "../../../assets/images/message-question-customize.svg";
import CustomizationGroup from "../../../components/customization-group-component/customization-group.page";
import SelectBackgroundComponent from "../../../components/select-background.component";
import SelectColorGroupComponent from "../../../components/select-color-group.component";
import {
  backgroundTypeEnum,
  theme1ElementCustomize,
  theme1IdScrollView,
} from "../../../constants/store-web-page.constants";

const CustomPageDetailCustomize = (props) => {
  const { updateFormValues, onChange, pageConfig } = props;
  const pageData = {
    customPageContentHint: t("storeWebPage.customPageContentHint"),
    pageManagement: t("storeWebPage.pageManagement"),
    header: t("storeWebPage.header.title"),
    pageContent: t("storeWebPage.pageContent"),
    customPage: t("storeWebPage.customPage"),
  };

  useEffect(() => {
    document.title = pageData.customPage;
  }, []);

  useEffect(() => {
    if (updateFormValues) {
      updateFormValues();
    }
  });

  const onChangeBackgroundBlog = (value, name) => {
    let changedValue = {
      key: [],
      value: null,
    };
    if (value === backgroundTypeEnum.IMAGE) {
      changedValue.key = ["config", name, "backgroundColor"];
    } else {
      changedValue.key = ["config", name, "backgroundImage"];
    }
    if (onChange) {
      onChange(changedValue);
    }
  };

  return (
    <>
      <CustomizationGroup
        title={pageData.header}
        defaultActiveKey={1}
        isShowKey={true}
        isNormal={true}
        content={
          <>
            <SelectBackgroundComponent
              {...props}
              formItemPreName={["config", "header"]}
              backgroundCustomize={pageConfig?.config?.header}
              onChangeBackgroundType={(value) => onChangeBackgroundBlog(value, "header")}
              maxSizeUploadMb={20}
              defaultImage={backgroundHeaderDefault}
            />
            <SelectColorGroupComponent {...props} formItemPreName={["config", "header"]} />
          </>
        }
        clickToScroll={theme1IdScrollView.CustomPageHeader}
        customizeKey={theme1ElementCustomize.CustomPageHeader}
      />
      <CustomizationGroup
        title={pageData.pageContent}
        isShowTooltip={true}
        defaultActiveKey={1}
        isShowKey={true}
        titleIconRight={
          <span>
            {pageData.customPageContentHint}
            <a href="/online-store/page-management" target="_blank">
              {pageData.pageManagement}
            </a>
          </span>
        }
        typeTooltip={"hyperlink"}
        icon={<MessageQuestionCustomizeIcon />}
        content={
          <>
            <SelectBackgroundComponent
              {...props}
              formItemPreName={["config", "content"]}
              backgroundCustomize={pageConfig?.config?.content}
              onChangeBackgroundType={(value) => onChangeBackgroundBlog(value, "content")}
              maxSizeUploadMb={20}
              defaultImage={backgroundContentDefault}
            />
            <SelectColorGroupComponent {...props} formItemPreName={["config", "content"]} />
          </>
        }
        clickToScroll={theme1IdScrollView.CustomPageContent}
        customizeKey={theme1ElementCustomize.CustomPageContent}
      />
    </>
  );
};

export default CustomPageDetailCustomize;
